var map = {
	"./avatar.jpg": "915e",
	"./bg_hiking.jpg": "7b6b",
	"./bg_homepage.jpg": "a524",
	"./bg_new-setup.jpg": "69d2",
	"./bg_tech-computer.jpg": "baf2",
	"./bg_tech2.jpg": "b8ec",
	"./bg_workflow.jpg": "2621",
	"./logo.png": "cf05",
	"./projects/alicoupon.jpg": "fdfe",
	"./projects/elliot/dashboard.png": "078f",
	"./projects/elliot/order-details.png": "51c9",
	"./projects/elliot/wallet-add-card.png": "16a0",
	"./projects/elliot/wallet-addons.png": "a766",
	"./projects/elliot/wallet-invoices.png": "f389",
	"./projects/elliot/wallet.png": "ac3d",
	"./projects/eshop-1.png": "e5d0",
	"./projects/eshop-2.png": "103e",
	"./projects/eshop-3.png": "48e9",
	"./projects/eshop-4.png": "fb9d",
	"./projects/express.jpg": "b1f2",
	"./projects/expressvpn-connected.png": "b9c2",
	"./projects/expressvpn-locations.png": "dd3a",
	"./projects/expressvpn-settings.png": "0fa7",
	"./projects/fitnerss dashboard.png": "fe6d",
	"./projects/pubpeer-extensions.png": "5891",
	"./projects/pubpeer-publication.png": "4ed5",
	"./projects/pubpeer-search.png": "e660",
	"./projects/timeline-event-filebrowser.png": "6c1b",
	"./projects/timeline-event-timeline.png": "8eb1",
	"./projects/timeline-feedback-graphic.png": "7131",
	"./projects/timeline-feedback-web.png": "7d20",
	"./svg/apple.svg": "3376",
	"./svg/book-open.svg": "9eef",
	"./svg/box.svg": "64f0",
	"./svg/briefcase.svg": "19b6",
	"./svg/code.svg": "0e19",
	"./svg/code2.svg": "3b63",
	"./svg/display.svg": "a626",
	"./svg/email.svg": "da8d",
	"./svg/eyedropper.svg": "5126",
	"./svg/github.svg": "76f4",
	"./svg/hand-paper-o.svg": "12e8",
	"./svg/handshake.svg": "d9c9",
	"./svg/home.svg": "f2a5",
	"./svg/instagram.svg": "48d6",
	"./svg/jquery.svg": "45c0",
	"./svg/link.svg": "01df",
	"./svg/linkedin.svg": "b2c5",
	"./svg/mail.svg": "4f1b",
	"./svg/menu.svg": "1f69",
	"./svg/phone.svg": "1f9a",
	"./svg/share.svg": "940a",
	"./svg/skype.svg": "3e50",
	"./svg/telegram.svg": "e44e",
	"./svg/twitter.svg": "5a0b",
	"./svg/user.svg": "4d66",
	"./svg/wordpress.svg": "eee7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";